import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { Router, RouterLink } from '@angular/router';
import { AuthService, extractErrorMessage } from '../../../../core/services/auth.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-login',
  imports: [CommonModule, FormsModule, RouterLink, MatProgressSpinnerModule, MatFormFieldModule, MatInputModule, MatIconModule, MatButtonModule ,TranslateModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent {
  username = signal('');
  password = signal('');
  isLoading = signal(false);
  errorMessage = signal<string | null>(null);
  showPassword = signal(false);
  sessionExpired = signal(false);
  private translate = inject(TranslateService);

  constructor(
    private authService: AuthService,
    private router: Router
  ) {
    // Уже вошедшему экран входа не нужен
    if (this.authService.isAuthenticated()) {
      this.navigateAfterLogin();
      return;
    }
    this.sessionExpired.set(this.authService.consumeSessionExpired());
    // Ошибка, с которой сюда вернули (например, из callback e-Kyzmat)
    this.errorMessage.set(this.authService.authError());
    this.authService.setAuthError(null);
  }

  private navigateAfterLogin(): void {
    const isStaff = ['quota_operator', 'quota_manager', 'quota_admin', 'quota_viewer']
      .some(role => this.authService.hasRole(role));
    this.router.navigate([isStaff ? '/admin' : '/'], { replaceUrl: true });
  }

  onSubmit(): void {
    if (!this.username() || !this.password()) {
      this.errorMessage.set('Пожалуйста, заполните все поля');
      return;
    }

    this.isLoading.set(true);
    this.errorMessage.set(null);

    this.authService.login({
      username: this.username(),
      password: this.password()
    }).subscribe({
      next: () => {
        this.isLoading.set(false);
        this.navigateAfterLogin();
      },
      error: (error) => {
        console.error('Login failed:', error);
        this.isLoading.set(false);
        this.errorMessage.set('Неверный логин или пароль');
      }
    });
  }

  togglePasswordVisibility(): void {
    this.showPassword.update(value => !value);
  }

  onEkyzmatLogin(): void {
    this.isLoading.set(true);
    this.errorMessage.set(null);

    this.authService.getOAuthUrl().subscribe({
      next: (response) => {
        if (response.authorization_url) {
          window.location.href = response.authorization_url;
        } else {
          this.isLoading.set(false);
          this.errorMessage.set(this.translate.instant('login.oauthUrlFailed'));
        }
      },
      error: (error) => {
        this.isLoading.set(false);
        this.errorMessage.set(extractErrorMessage(error, this.translate.instant('login.oauthUrlFailed')));
      }
    });
  }
}
